var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9958 59.4617C69.4029 59.4617 75.4076 53.4003 75.4076 45.9231C75.4076 38.446 69.4029 32.3846 61.9958 32.3846C54.5887 32.3846 48.584 38.446 48.584 45.9231C48.584 53.4003 54.5887 59.4617 61.9958 59.4617ZM61.9958 62.8463C71.2547 62.8463 78.7605 55.2695 78.7605 45.9231C78.7605 36.5767 71.2547 29 61.9958 29C52.7369 29 45.2311 36.5767 45.2311 45.9231C45.2311 55.2695 52.7369 62.8463 61.9958 62.8463Z",
    fill: "#2D3436",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9412 74.6922C43.6082 74.6922 36.8529 81.5113 36.8529 89.9231V93.3077C36.8529 94.2423 36.1024 95 35.1765 95C34.2506 95 33.5 94.2423 33.5 93.3077V89.9231C33.5 79.642 41.7564 71.3076 51.9412 71.3076H72.0588C82.2436 71.3076 90.5 79.642 90.5 89.9231V93.3077C90.5 94.2423 89.7494 95 88.8235 95C87.8976 95 87.1471 94.2423 87.1471 93.3077V89.9231C87.1471 81.5113 80.3918 74.6922 72.0588 74.6922H51.9412Z",
    fill: "#2D3436",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.da095495e93ea8d7a24466ce8d7df82e.svg";
export { ForwardRef as ReactComponent };